import { Common } from '~/models/common';
import { FooterMenu } from '~/models/footer-menu';

export const footerMenuService = {
	fetch: async (): Promise<FooterMenu.Model[]> => {
		const params = {
			filter: {
				status: Common.Status.PUBLISHED,
			},
			fields: ['*', 'to.url'],
		};

		try {
			const response = await $fetch<FooterMenu.Model[]>(FooterMenu.api, {
				method: 'POST',
				body: { params },
			});

			return response;
		} catch (error) {
			console.error('Failed to fetch FooterMenu:', error);

			return [];
		}
	},
};
